export const getProfileName = (profiles, id) => {
  const profile = profiles.find((profile) => profile.id === id);

  if (profile) {
    return profile.name;
  }

  return null;
};
